export default __webpack_public_path__ + "static/media/logo-blue.def3bc83.png";